'use client';
import { jsx } from '@emotion/react';

const Flex = ({ children = null, xStyle, ...props }) => {
	return jsx(
		'div',
		{
			css: theme => ({
				display: 'flex',
				...(typeof xStyle === 'function' ? xStyle(theme) : xStyle),
				...props,
			}),
		},
		...(typeof children === 'array' ? children : [children]),
	);
};

export default Flex;
